// extracted by mini-css-extract-plugin
export default {"container":"DCInfo_container__CNwef","centered":"DCInfo_centered__fkBgl","meta":"DCInfo_meta__eWvUO","phones":"DCInfo_phones__XBRk5","phone":"DCInfo_phone__0vjmF"};